module.exports = __webpack_public_path__ + "img/9step-02-03-1_ergebnis.58b7ef8e.webp";